export default __webpack_public_path__ + "dfdc8c39381a2d7a18fcaf76493d4a72.png";